import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiMapPin, FiFacebook, FiTwitter, FiInstagram, FiLinkedin } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Notice Section */}
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 mx-4 mb-8 rounded-r-lg">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <span className="text-yellow-400 text-xl">⚠️</span>
          </div>
          <div className="ml-3">
            <p className="text-sm text-yellow-700">
              <strong>Notice:</strong> This website is created only for student practice. Account4Web experts have not fixed technical issues here – so you can clearly see the real work level of students. Almost 80% of the website is perfect, and the remaining 20% is polished by experts in final projects.
            </p>
            <p className="text-sm text-yellow-700 mt-2">
              🔒 We never share any client website made under this offer with others – your project privacy is 100% safe.
            </p>
            <p className="text-sm text-yellow-700 mt-2">
              👉 <a 
                href="https://projects.azaansuperpc.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 underline"
              >
                Check Offer
              </a>
            </p>
          </div>
        </div>
      </div>

      <footer className="bg-black text-white">
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <img 
                  src="https://i.ibb.co/39wSX117/round-logo.png" 
                  alt="AutoFix Pro Logo" 
                  className="h-10 w-10"
                />
                <div>
                  <h3 className="text-xl font-bold">AutoFix</h3>
                  <p className="text-red-500 text-sm font-semibold">PRO</p>
                </div>
              </div>
              <p className="text-gray-400 mb-4">
                Your trusted automotive repair partner with over 15 years of experience in quality car care and maintenance services.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-red-500 transition-colors">
                  <SafeIcon icon={FiFacebook} className="text-xl" />
                </a>
                <a href="#" className="text-gray-400 hover:text-red-500 transition-colors">
                  <SafeIcon icon={FiTwitter} className="text-xl" />
                </a>
                <a href="#" className="text-gray-400 hover:text-red-500 transition-colors">
                  <SafeIcon icon={FiInstagram} className="text-xl" />
                </a>
                <a href="#" className="text-gray-400 hover:text-red-500 transition-colors">
                  <SafeIcon icon={FiLinkedin} className="text-xl" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-red-500">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="text-gray-400 hover:text-white transition-colors">
                    Services
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-red-500">Our Services</h4>
              <ul className="space-y-2 text-gray-400">
                <li>Engine Repair</li>
                <li>Brake Service</li>
                <li>Oil Change</li>
                <li>Tire Service</li>
                <li>Transmission Repair</li>
                <li>AC Repair</li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-red-500">Contact Info</h4>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiMapPin} className="text-red-500 flex-shrink-0" />
                  <span className="text-gray-400">123 Auto Street, Car City, CC 12345</span>
                </div>
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiPhone} className="text-red-500 flex-shrink-0" />
                  <span className="text-gray-400">(555) 123-4567</span>
                </div>
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiMail} className="text-red-500 flex-shrink-0" />
                  <span className="text-gray-400">info@autofixpro.com</span>
                </div>
              </div>
              <div className="mt-4">
                <h5 className="font-semibold text-white mb-2">Business Hours</h5>
                <p className="text-gray-400 text-sm">
                  Mon-Fri: 8AM-6PM<br />
                  Saturday: 9AM-4PM<br />
                  Sunday: Closed
                </p>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-800 mt-12 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm mb-4 md:mb-0">
                © {currentYear} AutoFix Pro. All rights reserved.
              </p>
              <p className="text-gray-400 text-sm">
                Domain + Hosting + Design = <a 
                  href="https://account4web.ca" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-red-500 hover:text-red-400 transition-colors"
                >
                  Account4Web Inc
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;